import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedModule } from '../shared/shared.module';
import { AlertBannerComponent } from './alert-banner/alert-banner.component';
import { AlertDetailComponent } from './alert-detail/alert-detail.component';

@NgModule({
  declarations: [
    AlertBannerComponent,
    AlertDetailComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    SharedModule,
  ],
  exports: [
    AlertBannerComponent
  ]
})
export class AlertBannerModule { }
